import { MessagesService } from "../../common/api.service"

export default {
  namespaced: true,
  state: {
    messages: {},
  },
  mutations: {
    setMessages(state, payload) {
      state.messages = payload.messages
    },
  },
  actions: {
    async  fetchMessages({ commit }, {lg2, locale}) {
      return await MessagesService.get(lg2, locale)
      .then(({ data }) => {
        commit('setMessages', data)
        commit('setLg2', data.lang, { root: true })
        return data
      })
      .catch((reason) => {
        console.log(reason.message)
      })
    },
  },
  getters: {
  }
}